import * as appModels from '../models/appModels';
import * as appHelper from './appHelper';
import * as dataHelpers from './dataHelper';
import * as kpiHelper from './kpiHelper';
import * as indicatorHelper from './indicatorHelper';
import * as objectConstants from '../constants/objectConstants';

import * as localStorage from '../localStorage/localStorage';
import {KPI_VALUES_TO_COLOUR_LIST} from '../models/kpiModels';
import _ from 'lodash';


export function updateExperienceLocale(userData, lang) {
    return new Promise((resolve, reject) => {
        userData = Object.assign({}, userData, {
            lang: lang,

        });
        resolve(userData);
    });
}

export function terminateBite(userData, bite) {
    return new Promise((resolve, reject) => {

        let biteIndex = appHelper.getArrayObjectIndexByKey(userData.bites, "bite_id", bite.bite_id);

        let biteUserData = appHelper.getArrayObjectByKey(userData.bites, "bite_id", bite.bite_id);

        biteUserData = Object.assign({}, biteUserData, {
            terminated: true
        });

        biteUserData = Object.assign({}, biteUserData, {
            status: getBiteStatus(biteUserData),
            required: getBiteRequired(biteUserData),
            percentageComplete: getBitePercentageComplete(biteUserData),
        });

        userData = Object.assign({}, userData, {
            bites: dataHelpers.immutableSplice(userData.bites, biteIndex, 1, biteUserData)
        });


        userData = Object.assign({}, userData, {
            status: getLessonStatus(userData.bites),
            percentageComplete: getLessonPercentageComplete(userData.bites),
        });


        resolve(userData);
    });
}

export function clearBiteUserData(userData, experience, bite) {
    return new Promise((resolve, reject) => {
        let biteMenu = {};
        if (appHelper.isDefined(experience.experience_learning_model)) {
            if (appHelper.isDefined(experience.learning_plan)) {
                biteMenu = Object.assign({}, experience.learning_plan);
            }
        }
        let biteIndex = appHelper.getArrayObjectIndexByKey(userData.bites, "bite_id", bite.bite_id);
        let biteUserData = setBiteUserData(bite, biteMenu);
        userData = Object.assign({}, userData, {
            bites: dataHelpers.immutableSplice(userData.bites, biteIndex, 1, biteUserData)
        });


        userData = Object.assign({}, userData, {

            status: getLessonStatus(userData.bites),
            percentageComplete: getLessonPercentageComplete(userData.bites),
        });
        resolve(userData);
    });
}

export function setInitialUserData(experience) {
    return new Promise((resolve, reject) => {
        let biteMenu = {};
        if (appHelper.isDefined(experience.experience_learning_model)) {
            if (appHelper.isDefined(experience.learning_plan)) {
                biteMenu = Object.assign({}, experience.learning_plan);
            }
        }

        let userData = Object.assign({}, appModels.USER_DATA_MODEL,
            {
                lang: appHelper.getArrayObjectByKey(experience.languages, "is_selected", true).language_code,
                resources: appHelper.isDefined(experience.resources) ? setResourcesUserData(experience.resources) : [],
                bites: setUserDataBites(experience.bites, biteMenu),
                attachments: setUserDataAttachments(experience.attachments),
                short_response_questions: appHelper.isDefined(experience.short_response_questions) ? setShortResponseQuestions(experience.short_response_questions) : [],
                badges: setExperienceBadges(experience.badges),
                //achievements: appHelper.isDefined(project.achievements) ? setUserDataAchievements(project.achievements) : [],
                notes: []
            }
        );

        //let the other data be set before doing this.
        userData = Object.assign({}, userData, {
            status: getLessonStatus(userData.bites),
            percentageComplete: getLessonPercentageComplete(userData.bites),
            score: 0
        });

       // console.log(userData);

        resolve(userData);
    });
}

function setExperienceBadges(badges) {
    let badgesUserData = [];
    for (let i = 0; i < badges.length; i++) {
        let badge = badges[i];
        let badgeObj = Object.assign({}, appModels.USER_DATA_BADGE, {
            badge_id: badge.badge_id,
        });
        badgesUserData = dataHelpers.immutablePush(badgesUserData, badgeObj);
    }
    return badgesUserData;
}

function setShortResponseQuestions(short_response_questions) {
    let shortResponseQuestionArray = [];
    for (let i = 0; i < short_response_questions.length; i++) {
        let responseQuestion = Object.assign({}, short_response_questions[i], {
            response: "",
        });
        shortResponseQuestionArray = dataHelpers.immutablePush(shortResponseQuestionArray, responseQuestion);
    }
    return shortResponseQuestionArray;
}

function setUserDataAttachments(attachments) {
    let attachmentsArray = [];
    for (let i = 0; i < attachments.length; i++) {
        let attachment = Object.assign({}, attachments[i], {
            status: objectConstants.STATUS_NOT_STARTED,
        });
        attachmentsArray = dataHelpers.immutablePush(attachmentsArray, attachment);
    }

    return attachmentsArray;
}


function setResourcesUserData(resources) {
    let resourcesArray = [];
    for (let i = 0; i < resources.length; i++) {
        let screen = resources[i];
        resourcesArray = dataHelpers.immutablePush(resourcesArray, setResourceScreenResult(screen));
    }

    return resourcesArray;
}


function setResourceScreenResult(screen) {
    return {
        screen_id: screen.screen_id,
        status: objectConstants.STATUS_NOT_STARTED,
        objects: setScreensObjects(screen.objects)
    };

}

/*
function setToolboxUserData(toolbox) {
    let userDataToolbox = Object.assign({}, appModels.USER_DATA_TOOLBOX,
        {
            active: toolbox.active,
            status: objectConstants.STATUS_NOT_STARTED,
            screens: setToolboxScreens(toolbox.screens),
        }
    );
    //console.log(JSON.stringify(userDataToolbox));
    return userDataToolbox;
}


//SET INIT TOOLBOX SCREEN DATA
function setToolboxScreens(screens) {
    let screensArray = [];
    for (let i = 0; i < screens.length; i++) {
        let screen = screens[i];
        screensArray = dataHelpers.immutablePush(screensArray, setToolboxScreenResult(screen));
    }

    return screensArray;
}

function setToolboxScreenResult(screen) {
    if (typeof screen.objects !== "undefined" || screen.objects.length > 0) {
        return Object.assign({}, appModels.USER_DATA_TOOLBOX_SCREEN,
            {
                toolbox_id: screen.toolbox_id,
                status: screen.required ? objectConstants.STATUS_NOT_STARTED : objectConstants.STATUS_COMPLETE,
                objects: setScreensObjects(screen.objects)
            }
        );
    } else {
        return Object.assign({}, appModels.USER_DATA_SCREEN,
            {
                screen_id: screen.screen_id,
                status: screen.required ? objectConstants.STATUS_NOT_STARTED : objectConstants.STATUS_COMPLETE
            }
        );
    }
}

//ACHIEVEMENTS
function setUserDataAchievements(achievements) {
    let achievementsUserData = [];
    for (let i = 0; i < achievements.length; i++) {
        let achievement = achievements[i];
        let achievementObj = Object.assign({}, appModels.USER_DATA_ACHIEVEMENT, {
            code: achievement.code,

        });
        achievementsUserData = dataHelpers.immutablePush(achievementsUserData, achievementObj);
    }
    return achievementsUserData;
}

*/

//BITES
function setUserDataBites(bites, biteMenu) {
    let bitesUserData = [];

    for (let i = 0; i < bites.length; i++) {
        let bite = bites[i];
        //console.log(appHelper.getLocalData(bite).title);
        bitesUserData = dataHelpers.immutablePush(bitesUserData, setBiteUserData(bite, biteMenu));
    }
    return bitesUserData;
}

function setBiteUserData(bite, biteMenu) {

    let userDataBite = Object.assign({}, appModels.USER_DATA_BITE,
        {
            bite_id: bite.bite_id,
            status: objectConstants.STATUS_NOT_STARTED,
            scoring_type: appHelper.isDefined(bite.scoring_type) ? bite.scoring_type : "",
            screens: setBiteScreens(bite),
            score_kpi_id: appHelper.isDefined(bite.score_kpi) && bite.score_kpi.kpi_id !== null ? bite.score_kpi.id : 0,
            kpis: setBiteKpis(bite),
            indicators: setBiteIndicators(bite),
            //badges: setBitesBadges(bite.bite_id, bite.badges),
            target_screens: appHelper.isDefined(bite.target_screens) ? bite.target_screens : [],
            number_of_target_screens: bite.number_of_target_screens,
            complete_target_screens: [],
            terminated: false,
        }
    );

    let required = getBiteRequired(userDataBite);
    let biteRules = [];
    let weight = 1;
    if (appHelper.isDefined(biteMenu.bites)) {
        let menuBite = appHelper.getArrayObjectByKey(biteMenu.bites, "bite_id", bite.bite_id);
        required = menuBite.display_rule === objectConstants.REQUIRED || menuBite.display_rule === objectConstants.CUSTOM;
        biteRules = appHelper.isDefined(menuBite.rules) ? menuBite.rules : biteRules;
        weight = appHelper.isDefined(menuBite.weight) ? menuBite.weight : weight;
    }

    //do this after screens have been updated
    userDataBite = Object.assign({}, userDataBite, {
        status: getBiteStatus(userDataBite),
        required: required,
        visible: true,
        percentageComplete: getBitePercentageComplete(userDataBite),
        rules: biteRules,
        weight: weight
    });



    return userDataBite;
}

function setBitesBadges(bite_id,badges) {
    let badgesUserData = [];
    for (let i = 0; i < badges.length; i++) {
        let badge = badges[i];
        let badgeObj = Object.assign({}, appModels.USER_DATA_BADGE, {
            badge_id: badge.badge_id,
            bite_id: bite_id
        });
        badgesUserData = dataHelpers.immutablePush(badgesUserData, badgeObj);
    }
    return badgesUserData;
}

//SET INIT SCREEN DATA
function setBiteScreens(bite) {
    let screensArray = [];
    for (let i = 0; i < bite.screens.length; i++) {
        let screen = bite.screens[i];
        screensArray = dataHelpers.immutablePush(screensArray, setScreenResult(screen, bite));
    }

    return screensArray;
}

function setScreenResult(screen, bite) {
    let required = screen.screen_rule_type !== objectConstants.SCREEN_RULE_TYPE_OPTIONAL;

    return {
        screen_id: screen.screen_id,
        status: required ? objectConstants.STATUS_NOT_STARTED : objectConstants.STATUS_NOT_REQUIRED,
        required: required,
        isTargetScreen: screen.screen_rule_type == objectConstants.SCREEN_RULE_TYPE_TARGET,
        sub_screens: appHelper.isDefined(screen.sub_screens) ? setBiteSubScreens(bite, screen) : [],
        screen_rule_type: screen.screen_rule_type,
        objects: appHelper.isDefined(screen.objects) ? setScreensObjects(screen.objects) : []
    };
}


function setBiteSubScreens(bite, parentScreen) {
    let screensArray = [];
    for (let i = 0; i < parentScreen.sub_screens.length; i++) {
        let screen = parentScreen.sub_screens[i];
        screensArray = dataHelpers.immutablePush(screensArray, setSubScreenResult(screen, parentScreen, bite));
    }

    return screensArray;
}

function setSubScreenResult(screen, parentScreen, bite) {
    let required = screen.screen_rule_type !== objectConstants.SCREEN_RULE_TYPE_OPTIONAL;

    return {
        screen_id: screen.screen_id,
        status: required ? objectConstants.STATUS_NOT_STARTED : objectConstants.STATUS_NOT_REQUIRED,
        required: required,
        isTargetScreen: screen.screen_rule_type == objectConstants.SCREEN_RULE_TYPE_TARGET,
        sub_screens: appHelper.isDefined(screen.sub_screens) ? setBiteSubScreens(bite, screen) : [],
        screen_rule_type: screen.screen_rule_type,
        objects: appHelper.isDefined(screen.objects) ? setScreensObjects(screen.objects) : []
    };

}

//SET INIT OBJECT DATA
function setScreensObjects(objects) {
    let objectArray = [];
    for (let i = 0; i < objects.length; i++) {
        let object = objects[i];
        objectArray = dataHelpers.immutablePush(objectArray, setObjectResult(object));
    }
    return objectArray;
}

function setObjectResult(object) {
    let required = !appHelper.isDefined(object.required_for_completion) || (appHelper.isDefined(object.required_for_completion) && object.required_for_completion);
    return Object.assign({}, appModels.USER_DATA_SCREEN_OBJECT,
        {
            asset_id: object.asset_id,
            asset_type_code: object.asset_type_code,
            required: required,
            status: required ? objectConstants.STATUS_NOT_STARTED : objectConstants.STATUS_COMPLETE
        }
    );
}

//SET KPI DATA

function setBiteKpis(bite) {
    let kpisArray = [];

    let has_score_kpi = appHelper.isDefined(bite.score_kpi);
    let has_performance_kpis = appHelper.isDefined(bite.performance_kpis);
    if (has_score_kpi && bite.score_kpi.kpi_id !== null) {
        kpisArray = dataHelpers.immutablePush(kpisArray, setBiteKpiData(bite.score_kpi, bite.screens, true));
    }
    if (has_performance_kpis) {
        for (let i = 0; i < bite.performance_kpis.length; i++) {
            let kpi = bite.performance_kpis[i];
            kpisArray = dataHelpers.immutablePush(kpisArray, setBiteKpiData(kpi, bite.screens, false));
        }
    }

    return kpisArray;
}

function setBiteKpiData(kpi, screens, is_primary) {
    let biteKpiData = Object.assign({}, appModels.USER_DATA_BITE_KPI,
        {
            kpi_id: kpi.kpi_id,
            is_primary: is_primary,
            min: kpi.min,
            max: kpi.max,
            start: kpi.start,
            current: kpi.start,
            yellow: kpi.include_yellow ? kpi.yellow : 0,
            green: kpi.green,
            style: kpi.style,
            unit_type: kpi.unit_type,
            is_visible: kpi.is_visible,
            positive_type: kpi.positive_type,
            decimals_points: parseInt(kpi.decimals_points),
            totalPoints: kpiHelper.getBiteKpiTotalPoints(screens, kpi.kpi_id),
            currentScoreRange: kpiHelper.getKpiScoreRange(kpi, kpi.start),
            last: kpi.start,
            include_yellow: kpi.include_yellow,
            //affects_personal_learning_plan: kpi.affects_personal_learning_plan,
            //learning_plan_outcomes: kpi.learning_plan_outcomes
        }
    );

    return biteKpiData;
}

// SET BITE INDICATORS

function setBiteIndicators(bite) {
    let indicatorsArray = [];

    let has_indicators = appHelper.isDefined(bite.indicators) && bite.indicators.length > 0;

    if (has_indicators) {
        for (let i = 0; i < bite.indicators.length; i++) {
            let indicator = bite.indicators[i];
            if(indicator.outcomes.length > 0) {
                indicatorsArray = dataHelpers.immutablePush(indicatorsArray, setBiteIndicatorData(indicator));
            }
        }
    }

    //console.log(`indicatorsArray`, indicatorsArray);

    return indicatorsArray;
}

function setBiteIndicatorData(indicator) {
    //console.log(`indicator`,indicator);

    //console.log(`setBiteIndicatorData`,indicator.outcomes[0].to);

    let toValueString = indicator.outcomes[0].to.toString();

    if(toValueString.indexOf("<") > -1) {
        let firstOutcome = indicator.outcomes[0];
        let lastOutcome = indicator.outcomes[indicator.outcomes.length - 1];
        let outcomes = setLessThanBiteIndicatorOutcomeData(indicator.outcomes);
        let biteIndicatorData = Object.assign({}, appModels.USER_DATA_BITE_INDICATOR,
            {
                indicator_id: indicator.indicator_id,
                min: parseInt(firstOutcome.from),
                max: parseInt(lastOutcome.to),
                start: parseInt(firstOutcome.from),
                current: parseInt(firstOutcome.from),
                totalPoints: parseInt(lastOutcome.to),
                currentOutcome: outcomes[0],
                last: parseInt(firstOutcome.from),
                outcomes: outcomes
            }
        );
        //console.log(`setBiteIndicatorData`,biteIndicatorData);
        return biteIndicatorData;
    }else{

        let outcomeArray = dataHelpers.immutableReverse(indicator.outcomes);
        let firstOutcome = outcomeArray[0];
        let lastOutcome = outcomeArray[indicator.outcomes.length - 1];
        let outcomes = setGreaterThanBiteIndicatorOutcomeData(outcomeArray);
        let biteIndicatorData = Object.assign({}, appModels.USER_DATA_BITE_INDICATOR,
            {
                indicator_id: indicator.indicator_id,
                min: parseInt(firstOutcome.to),
                max: parseInt(lastOutcome.from),
                start: parseInt(firstOutcome.to),
                current: parseInt(firstOutcome.to),
                totalPoints: parseInt(lastOutcome.from),
                currentOutcome: outcomes[0],
                last: parseInt(firstOutcome.to),
                outcomes: outcomes
            }
        );
        //console.log(`setBiteIndicatorData`,biteIndicatorData);
        return biteIndicatorData;
    }

}


function setLessThanBiteIndicatorOutcomeData(outcomes) {
    let outcomeArray = [];
    for (let i = 0; i < outcomes.length; i++) {
        let outcome = outcomes[i];
        let isLastOutcome = i === outcomes.length - 1;
        let outcomeData = Object.assign({}, appModels.USER_DATA_BITE_INDICATOR_OUTCOME,
            {
                indicator_outcome_id: outcome.indicator_outcome_id,
                from: parseInt(outcome.from),
                to: isLastOutcome ? outcome.to : outcomes[i + 1].from,
                is_last_outcome: isLastOutcome,
                must_be_less_than_to_value: !isLastOutcome,
            }
        );
        outcomeArray = dataHelpers.immutablePush(outcomeArray, outcomeData);
    }

    return outcomeArray;
}

function setGreaterThanBiteIndicatorOutcomeData(outcomes) {
    //console.log(`setGreaterThanBiteIndicatorOutcomeData`, outcomes);

    let outcomeArray = [];
    for (let i = 0; i < outcomes.length; i++) {
        let outcome = outcomes[i];
        let isFirstOutcome = i === 0;
        let isLastOutcome = i === outcomes.length - 1;
        let outcomeData = Object.assign({}, appModels.USER_DATA_BITE_INDICATOR_OUTCOME,
            {
                indicator_outcome_id: outcome.indicator_outcome_id,
                from: isFirstOutcome ? outcome.to : outcomes[i - 1].from,
                to: outcome.from,
                is_last_outcome: isLastOutcome,
                must_be_less_than_to_value: !isLastOutcome,
            }
        );
        outcomeArray = dataHelpers.immutablePush(outcomeArray, outcomeData);
    }

    return outcomeArray;
}



export function storeUserResponse(params) {
    return new Promise((resolve, reject) => {

        let userData = Object.assign({}, params.userData);
        let bites = Object.assign([], params.userData.bites);
        let bite = appHelper.getArrayObjectByKey(params.userData.bites, "bite_id", params.bite_id);
        let biteIndex = appHelper.getArrayObjectIndexByKey(params.userData.bites, "bite_id", bite.bite_id);

        let bite_kpis = setBiteKpiResults(params);
        let bite_indicators =  setBiteIndicatorResults(params);
        //console.log(bite_kpis);
        let bite_screens = setScreenResults(params);

        bite = Object.assign({}, bite, {
            kpis: bite_kpis,
            indicators: bite_indicators,
            screens: bite_screens
        });

        //let learning_plan_outcomes = this.getLearningPlanOutcomes(bite_kpis);
        //console.log(learning_plan_outcomes);


        //do this after screens have been updated
        bite = Object.assign({}, bite, {
            status: getBiteStatus(bite),
            required: getBiteRequired(bite),
            percentageComplete: getBitePercentageComplete(bite),
        });

        if (biteIndex > -1) {
            bites = dataHelpers.immutableSplice(bites, biteIndex, 1, bite);
        } else {
            bites = dataHelpers.immutablePush(bites, bite);
        }

        /*if (learning_plan_outcomes.learning_plan_requires_updating) {
            bites = updateLearningPlanOutcomes(bites, learning_plan_outcomes.personal_learning_plan);
        }*/

        if (appHelper.isDefined(localStorage.contentData.experience.experience_learning_model)) {
            if (appHelper.isDefined(localStorage.contentData.experience.learning_plan)) {
                let biteMenu = Object.assign({}, localStorage.contentData.experience.learning_plan);
                bites = setBiteRequiredByRules(biteMenu, bites, userData.badges);
            }
        }


        userData = Object.assign({}, userData, {
            bites: bites
        });


        //let the other data be set before doing this.
        userData = Object.assign({}, userData, {
            status: getLessonStatus(userData.bites),
            percentageComplete: getLessonPercentageComplete(userData.bites),
        });

        // console.log(`userData`,userData);
        resolve(userData);
    });
}

function setBiteRequiredByRules(biteMenu, bites, badges) {
    //console.log(`setBiteRequiredByRules`);
    let updatedBites = [];
    _.forEach(biteMenu.bites, function (menuBite) {
        let bite = appHelper.getArrayObjectByKey(bites, "bite_id", menuBite.bite_id);
        if (appHelper.isDefined(menuBite.rules) && menuBite.rules.length > 0) {
            let ruleDefinitions = [];
            let ruleCombination = [];
            for (let i = 0; i < menuBite.rules.length; i++) {
                let biteRule = menuBite.rules[i];
                let rule = biteRule.rule;
                let result = false;
                let biteData = appHelper.getArrayObjectByKey(bites, "bite_id", rule.bite_id);
                //console.log(`biteRule`,biteRule);
                if (appHelper.isDefined(biteRule.condition)) {
                    //Push and Clear if an or statement
                    if (biteRule.condition === objectConstants.OR) {
                        ruleDefinitions = dataHelpers.immutablePush(ruleDefinitions, ruleCombination);
                        ruleCombination = dataHelpers.immutableSplice(ruleCombination, 0, ruleCombination.length);
                    }
                }

                if (appHelper.isDefined(biteRule.rule.kpi_id)) {
                    let kpi = appHelper.getArrayObjectByKey(biteData.kpis, "kpi_id", rule.kpi_id);
                    if(appHelper.isDefined(kpi)) {
                        let kpiResult = appHelper.getArrayObjectByKey(KPI_VALUES_TO_COLOUR_LIST, "value", kpi.currentScoreRange);
                        result = kpiResult.colour === rule.result;
                    }
                } else if (appHelper.isDefined(rule.badge_id)) {
                    //console.log(`here now`,badges);

                    let badge = appHelper.getArrayObjectByKey(badges, "badge_id", rule.badge_id);
                    if(appHelper.isDefined(badge)) {
                        if (rule.result === objectConstants.ACHIEVED && badge.achieved > 0) {
                            result = true;
                        } else if (rule.result === objectConstants.NOT_ACHIEVED && badge.achieved === 0) {
                            result = true;
                        }
                    }
                }else if(appHelper.isDefined(rule.indicator_id)){
                    //console.log(`set RULE`);
                    let indicator = appHelper.getArrayObjectByKey(biteData.indicators, "indicator_id", rule.indicator_id);
                    if(appHelper.isDefined(indicator)) {
                        result = indicator.currentOutcome.indicator_outcome_id === rule.indicator_outcome_id;
                    }
                    //console.log(indicator, indicator.currentOutcome.indicator_outcome_id,result);
                }

                rule = Object.assign({}, rule, {
                    success: result
                });

                ruleCombination = dataHelpers.immutablePush(ruleCombination, rule);
                if (i === menuBite.rules.length - 1) {
                    ruleDefinitions = dataHelpers.immutablePush(ruleDefinitions, ruleCombination);
                }

            }
            //time to check and update
            _.forEach(ruleDefinitions, function (ruleCombination) {
                let successCount = 0;
                let display_rule = "";
                _.forEach(ruleCombination, function (rule) {
                    if (rule.success) {
                        successCount++;
                    }
                    display_rule = rule.display_rule;
                });

                if (successCount === ruleCombination.length) {
                    if (display_rule === objectConstants.SCREEN_RULE_TYPE_REQUIRED) {
                        bite = Object.assign({}, bite, {
                            required: true,
                            visible: true
                        });
                    } else if (display_rule === objectConstants.SCREEN_RULE_TYPE_OPTIONAL) {
                        bite = Object.assign({}, bite, {
                            required: false,
                            visible: true
                        });
                    } else if (display_rule === objectConstants.SCREEN_RULE_TYPE_HIDDEN) {
                        bite = Object.assign({}, bite, {
                            required: false,
                            visible: false
                        });
                    }

                    return false;

                } else {
                    bite = Object.assign({}, bite, {
                        required: true
                    });
                }
                bite = Object.assign({}, bite, {
                    status: getBiteStatus(bite),
                    percentageComplete: getBitePercentageComplete(bite),
                });


            });

        }
        updatedBites = dataHelpers.immutablePush(updatedBites, bite);
    });

    return updatedBites;
}

export function updateScreenResults(userData, params) {
    return new Promise((resolve, reject) => {
        let bites = Object.assign([], userData.bites);
        let bite = appHelper.getArrayObjectByKey(bites, "bite_id", params.bite_id);
        let biteIndex = appHelper.getArrayObjectIndexByKey(bites, "bite_id", bite.bite_id);
        let screen = {};
        let screenIndex = -1;
        let screen_status = params.screen_status;
        let subScreen = {};
        let subScreenIndex = -1;
        //console.log(`updateScreenResults`,userData, params);
        if (appHelper.isDefined(params.parent_screen_id)) {

            screen = appHelper.getArrayObjectByKey(bite.screens, "screen_id", params.parent_screen_id);
            screenIndex = appHelper.getArrayObjectIndexByKey(bite.screens, "screen_id", params.parent_screen_id);
            let subScreen = getSubScreenUserData(userData, params.parent_screen_id, params.screen_id);
            let subScreenIndex = appHelper.getArrayObjectIndexByKey(screen.sub_screens, "screen_id", params.screen_id);

            if (appHelper.isDefined(params.asset_id)) {
                let object = appHelper.getArrayObjectByKey(subScreen.objects, "asset_id", params.asset_id);
                let objectIndex = appHelper.getArrayObjectIndexByKey(subScreen.objects, "asset_id", params.asset_id);
                if (appHelper.isDefined(params.result)) {
                    object = Object.assign({}, object,
                        {
                            status: params.object_status,
                            result: params.object_result
                        }
                    );
                } else {
                    object = Object.assign({}, object,
                        {
                            status: params.object_status,
                        }
                    );
                }

                subScreen = Object.assign({}, subScreen, {
                    status: screen_status,
                    objects: screen_status === objectConstants.STATUS_COMPLETE ? setAllScreenObjectsToComplete(subScreen.objects) : dataHelpers.immutableSplice(subScreen.objects, objectIndex, 1, object)
                });
            } else {
                subScreen = Object.assign({}, subScreen, {
                    status: screen_status,
                    objects: screen_status === objectConstants.STATUS_COMPLETE ? setAllScreenObjectsToComplete(subScreen.objects) : subScreen.objects
                });
            }
            screen = Object.assign({}, screen, {
                status: screen.status === objectConstants.STATUS_COMPLETE || screen.status === objectConstants.STATUS_NOT_REQUIRED ? screen.status : objectConstants.STATUS_IN_PROGRESS,
                sub_screens: dataHelpers.immutableSplice(screen.sub_screens, subScreenIndex, 1, subScreen)
            });
        } else {
            screen = appHelper.getArrayObjectByKey(bite.screens, "screen_id", params.screen_id);
            screenIndex = appHelper.getArrayObjectIndexByKey(bite.screens, "screen_id", params.screen_id);

            if (appHelper.isDefined(params.asset_id)) {
                let object = appHelper.getArrayObjectByKey(screen.objects, "asset_id", params.asset_id);
                let objectIndex = appHelper.getArrayObjectIndexByKey(screen.objects, "asset_id", params.asset_id);

                if (appHelper.isDefined(params.result)) {
                    object = Object.assign({}, object,
                        {
                            status: params.object_status,
                            result: params.object_result
                        }
                    );
                } else {
                    object = Object.assign({}, object,
                        {
                            status: params.object_status,
                        }
                    );
                }

                if (screen.status === objectConstants.STATUS_NOT_REQUIRED) {
                    screen_status = objectConstants.STATUS_NOT_REQUIRED;
                }

                if (appHelper.isDefined(screen.sub_screens) && screen.sub_screens.length > 0) {
                    screen = Object.assign({}, screen, {
                        status: screen_status,
                        //objects: screen_status === objectConstants.STATUS_COMPLETE ? setAllScreenObjectsToComplete(screen.objects) : dataHelpers.immutableSplice(screen.objects, objectIndex, 1, object)
                    });
                } else {
                    screen = Object.assign({}, screen, {
                        status: screen_status,
                        objects: screen_status === objectConstants.STATUS_COMPLETE ? setAllScreenObjectsToComplete(screen.objects) : dataHelpers.immutableSplice(screen.objects, objectIndex, 1, object)
                        //sub_screens: screen_status === objectConstants.STATUS_COMPLETE ? setAllSubScreensToComplete(screen.sub_screens) : screen.sub_screens
                    });
                }
            } else {
                /*if (savedObjectExists > -1 && screen_status === objectConstants.STATUS_COMPLETE) {
                    screen_status = objectConstants.STATUS_IN_PROGRESS;
                }*/

                if (screen.status === objectConstants.STATUS_NOT_REQUIRED) {
                    screen_status = objectConstants.STATUS_NOT_REQUIRED;
                }
                if (appHelper.isDefined(screen.sub_screens) && screen.sub_screens.length > 0) {
                    screen = Object.assign({}, screen, {
                        status: screen_status,
                        objects: screen_status === objectConstants.STATUS_COMPLETE ? setAllScreenObjectsToComplete(screen.objects) : screen.objects
                    });
                } else {
                    screen = Object.assign({}, screen, {
                        status: screen_status,
                        //sub_screens: screen_status === objectConstants.STATUS_COMPLETE ? setAllSubScreensToComplete(screen.sub_screens) : screen.sub_screens
                    });
                }

                //console.log(`screen`,screen)
            }
        }
        let bite_screens = dataHelpers.immutableSplice(bite.screens, screenIndex, 1, screen);
        //TARGET SCREENS
        if (screen_status === objectConstants.STATUS_COMPLETE) {
            let isTargetScreen = appHelper.getArrayObjectIndexByKey(bite.target_screens, "screen_id", params.screen_id);
            if (isTargetScreen > -1) {

                let targetScreenAlreadyComplete = appHelper.getArrayObjectIndexByKey(bite.complete_target_screens, "screen_id", params.screen_id);
                if (targetScreenAlreadyComplete === -1) {
                    let targetScreenObject = {
                        screen_id: params.screen_id
                    };

                    bite = Object.assign({}, bite, {
                        complete_target_screens: dataHelpers.immutablePush(bite.complete_target_screens, targetScreenObject)
                    });
                }
            }
        }

        bite = Object.assign({}, bite, {
            screens: bite_screens
        });

        //console.log(`bite`,bite);

        //do this after screens have been updated
        bite = Object.assign({}, bite, {
            status: getBiteStatus(bite),
            //required: getBiteRequired(bite.screens),
            percentageComplete: getBitePercentageComplete(bite),
        });

        bites = dataHelpers.immutableSplice(bites, biteIndex, 1, bite);
        if (appHelper.isDefined(localStorage.contentData.experience.experience_learning_model)) {
            if (appHelper.isDefined(localStorage.contentData.experience.learning_plan)) {
                let biteMenu = Object.assign({}, localStorage.contentData.experience.learning_plan);
                //console.log(`biteMenu`,biteMenu);
                bites = setBiteRequiredByRules(biteMenu, bites, userData.badges);
            }
        }

        userData = Object.assign({}, userData, {
            bites: bites
        });

        //let the other data be set before doing this.
        userData = Object.assign({}, userData, {
            status: getLessonStatus(userData.bites),
            percentageComplete: getLessonPercentageComplete(userData.bites),
        });
       // console.log(JSON.stringify(userData));

        resolve(userData);
    });

}

function setAllSubScreensToComplete(subScreens) {
    let subScreenArray = [];
    for (let i = 0; i < subScreens.length; i++) {
        let subScreen = subScreens[i];
        subScreen = Object.assign({}, subScreens, {
            status: objectConstants.STATUS_COMPLETE,
            objects: setAllScreenObjectsToComplete(subScreen.objects)
        });
        subScreenArray = dataHelpers.immutablePush(subScreenArray, subScreen);
    }
    return subScreenArray;
}

function setAllScreenObjectsToComplete(objects) {
    let objectArray = [];
    for (let i = 0; i < objects.length; i++) {
        let object = objects[i];
        object = Object.assign({}, object, {
            status: objectConstants.STATUS_COMPLETE
        });
        objectArray = dataHelpers.immutablePush(objectArray, object);
    }
    return objectArray;
}

function setScreenResults(params) {

    let bite = appHelper.getArrayObjectByKey(params.userData.bites, "bite_id", params.bite_id);
    let biteScreens = [];
    if (!appHelper.isDefined(params.parent_screen_id)) {
        let screen = appHelper.getArrayObjectByKey(bite.screens, "screen_id", params.screen_id);
        let screenIndex = appHelper.getArrayObjectIndexByKey(bite.screens, "screen_id", params.screen_id);
        let screenUserData = getScreenUserData(params.userData, params.screen_id);
        let object = appHelper.getArrayObjectByKey(screen.objects, "asset_id", params.asset_id);
        let objectIndex = appHelper.getArrayObjectIndexByKey(screen.objects, "asset_id", params.asset_id);

        let status = objectConstants.STATUS_IN_PROGRESS;
        if (screenUserData.status === objectConstants.STATUS_COMPLETE) {
            status = objectConstants.STATUS_COMPLETE;
        } else if (screenUserData.status === objectConstants.STATUS_NOT_REQUIRED || !screenUserData.required) {
            status = objectConstants.STATUS_NOT_REQUIRED;
        }
        screen = Object.assign({}, screen, {
            status: status,
            objects: dataHelpers.immutableSplice(screen.objects, objectIndex, 1, object)
        });

        biteScreens = dataHelpers.immutableSplice(bite.screens, screenIndex, 1, screen);

    } else {
        let parent_screen = appHelper.getArrayObjectByKey(bite.screens, "screen_id", params.parent_screen_id);
        let parentScreenIndex = appHelper.getArrayObjectIndexByKey(bite.screens, "screen_id", params.parent_screen_id);
        let parentScreenUserData = getScreenUserData(params.userData, params.parent_screen_id);

        let sub_screen = appHelper.getArrayObjectByKey(parent_screen.sub_screens, "screen_id", params.screen_id);

        let sub_screen_index = appHelper.getArrayObjectIndexByKey(parent_screen.sub_screens, "screen_id", params.screen_id);


        let subScreenUserData = getSubScreenUserData(params.userData, params.parent_screen_id, params.screen_id);
        let object = appHelper.getArrayObjectByKey(sub_screen.objects, "asset_id", params.asset_id);


        let objectIndex = appHelper.getArrayObjectIndexByKey(sub_screen.objects, "asset_id", params.asset_id);

        let status = objectConstants.STATUS_IN_PROGRESS;
        let parentStatus = objectConstants.STATUS_IN_PROGRESS;

        if (subScreenUserData.status === objectConstants.STATUS_COMPLETE) {
            status = objectConstants.STATUS_COMPLETE;
        } else if (subScreenUserData.status === objectConstants.STATUS_NOT_REQUIRED || !subScreenUserData.required) {
            status = objectConstants.STATUS_NOT_REQUIRED;
        }

        if (parentScreenUserData.status === objectConstants.STATUS_COMPLETE) {
            parentStatus = objectConstants.STATUS_COMPLETE;
        } else if (parentScreenUserData.status === objectConstants.STATUS_NOT_REQUIRED || !subScreenUserData.required) {
            parentStatus = objectConstants.STATUS_NOT_REQUIRED;
        }

        sub_screen = Object.assign({}, sub_screen, {
            status: status,
            objects: dataHelpers.immutableSplice(sub_screen.objects, objectIndex, 1, object)
        });
        parent_screen = Object.assign({}, parent_screen, {
            status: parentStatus,
            sub_screens: dataHelpers.immutableSplice(parent_screen.sub_screens, sub_screen_index, 1, sub_screen)
        });

        biteScreens = dataHelpers.immutableSplice(bite.screens, parentScreenIndex, 1, parent_screen);
    }
    return biteScreens;
}

export function getLearningPlanOutcomes(bite_kpis) {
    let personal_learning_plan = [];
    for (let i = 0; i < bite_kpis.length; i++) {
        let kpi = bite_kpis[i];
        if (appHelper.isDefined(kpi.affects_personal_learning_plan) && kpi.affects_personal_learning_plan) {
            for (let k = 0; k < kpi.learning_plan_outcomes.length; k++) {
                let learning_plan = kpi.learning_plan_outcomes[k];
                if (learning_plan.outcome === kpi.currentScoreRange) {
                    //console.log(learning_plan.bites.length);
                    for (let l = 0; l < learning_plan.bites.length; l++) {
                        personal_learning_plan = dataHelpers.immutablePush(personal_learning_plan, learning_plan.bites[l]);
                    }

                }
            }
        }
    }

    return {
        learning_plan_requires_updating: personal_learning_plan.length > 0,
        personal_learning_plan: personal_learning_plan
    };
}

export function updateLearningPlanOutcomes(bites, personal_learning_plan) {
    let new_bites = [];

    for (let i = 0; i < bites.length; i++) {
        let bite = bites[i];
        let plp_index = appHelper.getArrayObjectIndexByKey(personal_learning_plan, "bite_id", bite.bite_id);

        if (plp_index > -1) {
            //let screens = Object.assign([],bite.screens);
            let plp = appHelper.getArrayObjectByKey(personal_learning_plan, "bite_id", bite.bite_id);
            bite = Object.assign({}, bite, {
                required: plp.required,
                status: !plp.required ? objectConstants.STATUS_NOT_REQUIRED : bite.status,
                screens: setBiteScreenRequiredStatus(plp, bite.screens)
            });
        }
        new_bites = dataHelpers.immutablePush(new_bites, bite);
    }
    return new_bites;
}

function setBiteScreenRequiredStatus(personal_learning_plan, screens) {
    let updatedScreens = [];
    for (let i = 0; i < screens.length; i++) {
        let screen = screens[i];
        if (screen.required !== personal_learning_plan.required) {
            screen = Object.assign({}, screen, {
                required: personal_learning_plan.required,
                status: !personal_learning_plan.required ? objectConstants.STATUS_NOT_REQUIRED : screen.status,
            });
        }
        updatedScreens = dataHelpers.immutablePush(updatedScreens, screen);
    }
    return updatedScreens;
}

function setBiteKpiResults(params) {

    //console.log(`setBiteKpiResults`,params);
    let bite = appHelper.getArrayObjectByKey(params.userData.bites, "bite_id", params.bite_id);
    //console.log(`bite kpis`,bite.kpis);
    //console.log(`bite`,bite);
    let bite_kpis = [];


    if (typeof params.kpis !== 'undefined' && params.kpis.length > 0) {
        for (let i = 0; i < bite.kpis.length; i++) {

            let kpi = bite.kpis[i];
            if (kpi.kpi_id === null) {
                kpi = Object.assign({}, appModels.USER_DATA_BITE_KPI);
            }
            //console.log(`kpi`, kpi);
            //check to see if option exists in history
            let previousResult = kpiHelper.getKpiPreviousResultForObject(kpi.history, params.screen_id, params.asset_id, kpi.kpi_id);
            let previousResultIndex = kpiHelper.getKpiPreviousResultIndex(kpi.history, params.screen_id, params.asset_id, kpi.kpi_id);
            let attemptCount = typeof previousResult.attempt === "undefined" ? 1 : (previousResult.attempt + 1);
            let optionKpi = appHelper.getArrayObjectByKey(params.kpis, "kpi_id", parseInt(kpi.kpi_id));

            //console.log(`optionKpi`,optionKpi, params.kpis, kpi);
            let currentKpiValue = 0;
            let kpiValue = 0;
            if (appHelper.isDefined(optionKpi)) {
                kpiValue = kpiHelper.getKpiValue(optionKpi.value, kpi);
                if (kpiValue > 0) {
                    //console.log(`${kpi.current} + ${Math.abs(kpiValue)} = ${kpi.current + Math.abs(kpiValue)}`);
                    currentKpiValue = parseFloat(kpi.current) + Math.abs(parseFloat(kpiValue));

                    if (typeof previousResult.value == 'number') {
                        if (previousResult.value < 0) {
                            //console.log(`${currentKpiValue} = ${currentKpiValue} + ${Math.abs(previousResult.value)} = ${currentKpiValue + Math.abs(previousResult.value)}`)
                            currentKpiValue = parseFloat(currentKpiValue) + Math.abs(parseFloat(previousResult.value));
                        } else {
                            //console.log(`${currentKpiValue} = ${currentKpiValue}  ${previousResult.value} = ${currentKpiValue - previousResult.value}`)

                            currentKpiValue = parseFloat(currentKpiValue) - parseFloat(previousResult.value);
                        }
                    }

                    if (currentKpiValue > kpi.max) {
                        currentKpiValue = kpi.max;
                    }
                } else {
                    //console.log(`${kpi.current} - ${Math.abs(kpiValue)} = ${kpi.current - Math.abs(kpiValue)}`);
                    currentKpiValue = parseFloat(kpi.current) - Math.abs(parseFloat(kpiValue));

                    if (typeof previousResult.value == 'number') {
                        if (previousResult.value < 0) {
                            //console.log(`${currentKpiValue} = ${currentKpiValue} + ${Math.abs(previousResult.value)} = ${currentKpiValue + Math.abs(previousResult.value)}`)
                            currentKpiValue = parseFloat(currentKpiValue) + Math.abs(parseFloat(previousResult.value));
                        } else {
                            //console.log(`${currentKpiValue} = ${currentKpiValue}  ${previousResult.value} = ${currentKpiValue - previousResult.value}`)

                            currentKpiValue = parseFloat(currentKpiValue) - parseFloat(previousResult.value);
                        }
                    }

                    if (currentKpiValue < kpi.min) {
                        currentKpiValue = kpi.min;
                    }
                }
            } else {
                //console.log(`no kpis for this question`);
                currentKpiValue = kpi.current;
                //console.log(`currentKpiValue`, currentKpiValue);
            }

            let decimals_points = parseInt(kpi.decimals_points) > 2 ? parseInt(kpi.decimals_points) : 2;
            currentKpiValue = currentKpiValue.toFixed(decimals_points);

            let kpiHistory = Object.assign({}, kpi, {
                hasValue: appHelper.isDefined(optionKpi),
                kpi_id: kpi.kpi_id,
                parent_screen_id: params.parent_screen_id,
                screen_id: params.screen_id,
                asset_id: params.asset_id,
                option_id: appHelper.isDefined(params.selectedOptions) ? params.selectedOptions : [],
                current: parseFloat(currentKpiValue),
                value: parseFloat(kpiValue),
                currentScoreRange: kpiHelper.getKpiScoreRange(kpi, currentKpiValue),
                statusIndicatorClass: appHelper.isDefined(optionKpi) ? kpiHelper.getKpiPointsIndicatorClass(optionKpi.value, kpi.kpi_id) : kpiHelper.getKpiPointsIndicatorClass("n-a", kpi.kpi_id),
                attempt: attemptCount,
                history: []
            });

            kpi = Object.assign({}, kpi, {
                hasValue: appHelper.isDefined(optionKpi),
                last: kpi.current,
                current: parseFloat(currentKpiValue),
                value: parseFloat(kpiValue),
                history: previousResultIndex === -1 ? dataHelpers.immutablePush(kpi.history, kpiHistory) : dataHelpers.immutableSplice(kpi.history, previousResultIndex, 1, kpiHistory),
                currentScoreRange: kpiHelper.getKpiScoreRange(kpi, currentKpiValue),
                statusIndicatorClass: appHelper.isDefined(optionKpi) ? kpiHelper.getKpiPointsIndicatorClass(optionKpi.value, kpi.kpi_id) : kpiHelper.getKpiPointsIndicatorClass("n-a", kpi.kpi_id),
                attempt: attemptCount,
            });

            //console.log(kpi);

            //if(appHelper.isDefined(optionKpi) || (!appHelper.isDefined(optionKpi) && kpi.is_primary)){
            bite_kpis = dataHelpers.immutablePush(bite_kpis, kpi);
            //}

            //}
        }
    } else {
        bite_kpis = Object.assign([], bite.kpis);
    }

    //console.log(`bite_kpis`,bite_kpis);

    return bite_kpis;
}

function setBiteIndicatorResults(params) {

    //console.log(`setBiteIndicatorResults`,params);

        //console.log(`setBiteIndicatorResults`,params);
        let bite = appHelper.getArrayObjectByKey(params.userData.bites, "bite_id", params.bite_id);
        //console.log(`bite indicators`,bite.indicators);

        let bite_indicators = [];


        if (appHelper.isDefined(params.indicators) && params.indicators.length > 0) {
            for (let i = 0; i < bite.indicators.length; i++) {

                let indicator = bite.indicators[i];
                if (indicator.indicator_id === null) {
                    indicator = Object.assign({}, appModels.USER_DATA_BITE_INDICATOR);
                }
                //console.log(`indicator`, indicator);
                //check to see if option exists in history
                let previousResult = indicatorHelper.getPreviousIndicatorResultForObject(indicator.history, params.screen_id, params.asset_id);
                let previousResultIndex = indicatorHelper.getPreviousIndicatorResultResultIndex(indicator.history, params.screen_id, params.asset_id);
                let attemptCount = typeof previousResult.attempt === "undefined" ? 1 : (previousResult.attempt + 1);

                //console.log(`indicator`,indicator);
                let optionIndicator = appHelper.getArrayObjectByKey(params.indicators, "indicator_id", parseInt(indicator.indicator_id));

                //console.log(`optionIndicator`,optionIndicator, params.indicators, indicator);
                let currentIndicatorValue = 0;
                let indicatorValue = 0;
                //console.log(`previousResult`, previousResult);
                if (appHelper.isDefined(optionIndicator)) {
                    //console.log(`optionIndicator`, optionIndicator);
                    indicatorValue = optionIndicator.value;
                    if (indicatorValue > 0) {
                        //console.log(`${indicator.current} + ${Math.abs(indicatorValue)} = ${indicator.current + Math.abs(indicatorValue)}`);
                        currentIndicatorValue = parseFloat(indicator.current) + Math.abs(parseFloat(indicatorValue));

                        if (typeof previousResult.value == 'number') {
                            if (previousResult.value < 0) {
                                //console.log(`${currentIndicatorValue} = ${currentIndicatorValue} + ${Math.abs(previousResult.value)} = ${currentIndicatorValue + Math.abs(previousResult.value)}`)
                                currentIndicatorValue = parseFloat(currentIndicatorValue) + Math.abs(parseFloat(previousResult.value));
                            } else {
                                //console.log(`${currentIndicatorValue} = ${currentIndicatorValue}  ${previousResult.value} = ${currentIndicatorValue - previousResult.value}`)

                                currentIndicatorValue = parseFloat(currentIndicatorValue) - parseFloat(previousResult.value);
                            }
                        }

                        if (currentIndicatorValue > indicator.max) {
                            currentIndicatorValue = indicator.max;
                        }
                    } else {
                        //console.log(`${indicator.current} - ${Math.abs(indicatorValue)} = ${indicator.current - Math.abs(indicatorValue)}`);
                        currentIndicatorValue = parseFloat(indicator.current) - Math.abs(parseFloat(indicatorValue));

                        if (typeof previousResult.value == 'number') {
                            if (previousResult.value < 0) {
                                //console.log(`${currentIndicatorValue} = ${currentIndicatorValue} + ${Math.abs(previousResult.value)} = ${currentIndicatorValue + Math.abs(previousResult.value)}`)
                                currentIndicatorValue = parseFloat(currentIndicatorValue) + Math.abs(parseFloat(previousResult.value));
                            } else {
                                //console.log(`${currentIndicatorValue} = ${currentIndicatorValue}  ${previousResult.value} = ${currentIndicatorValue - previousResult.value}`)

                                currentIndicatorValue = parseFloat(currentIndicatorValue) - parseFloat(previousResult.value);
                            }
                        }

                        if (currentIndicatorValue < indicator.min) {
                            currentIndicatorValue = indicator.min;
                        }
                    }
                } /*else {
                    currentIndicatorValue = indicator.current;
                }*/

                //console.log(`currentIndicatorValue`, currentIndicatorValue, `indicatorValue`, indicatorValue);

                let currentOutcome = indicatorHelper.getIndicatorOutcome(indicator, currentIndicatorValue);

                if(!appHelper.isDefined(currentOutcome.indicator_outcome_id)){
                    currentOutcome = Object.assign({},indicator.outcomes[0]);
                }

               // console.log(`currentOutcome`,currentOutcome);

                let indicatorHistory = Object.assign({}, indicator, {
                    hasValue: appHelper.isDefined(optionIndicator),
                    indicator_id: indicator.indicator_id,
                    parent_screen_id: params.parent_screen_id,
                    screen_id: params.screen_id,
                    asset_id: params.asset_id,
                    option_id: appHelper.isDefined(params.selectedOptions) ? params.selectedOptions : [],
                    current: parseFloat(currentIndicatorValue),
                    value: parseFloat(indicatorValue),
                    currentOutcome: currentOutcome,
                    attempt: attemptCount,
                    history: []
                });
                //console.log(`currentOutcome:`, indicatorHelper.getIndicatorOutcome(indicator, currentIndicatorValue));
                if(appHelper.isDefined(optionIndicator)){

                    let currentIndicatorOutcome = indicatorHelper.getIndicatorOutcome(indicator, currentIndicatorValue);

                    if(!appHelper.isDefined(currentIndicatorOutcome.indicator_outcome_id)){
                        currentIndicatorOutcome =  Object.assign({},indicator.outcomes[0]);
                    }

                   // console.log(`currentIndicatorOutcome`,currentIndicatorOutcome, indicator.outcomes[0]);

                    indicator = Object.assign({}, indicator, {
                        hasValue: appHelper.isDefined(optionIndicator),
                        last: indicator.current,
                        current: parseFloat(currentIndicatorValue),
                        value: parseFloat(indicatorValue),
                        history: previousResultIndex === -1  ? dataHelpers.immutablePush(indicator.history, indicatorHistory) : dataHelpers.immutableSplice(indicator.history, previousResultIndex, 1, indicatorHistory),
                        currentOutcome: currentIndicatorOutcome,
                        attempt: attemptCount,
                    });
                }/*else{
                    indicator = Object.assign({}, indicator, {
                        hasValue: appHelper.isDefined(optionIndicator),
                        last: indicator.current,
                        current: parseFloat(currentIndicatorValue),
                        value: parseFloat(indicatorValue),
                        currentOutcome: indicatorHelper.getIndicatorOutcome(indicator, currentIndicatorValue),
                        attempt: attemptCount,
                    });
                }*/



                //console.log(indicator);

                //if(appHelper.isDefined(optionIndicator) || (!appHelper.isDefined(optionIndicator) && indicator.is_primary)){
                bite_indicators = dataHelpers.immutablePush(bite_indicators, indicator);
                //}

                //}*/
            }
        } else {
            bite_indicators = Object.assign([], bite.indicators);
        }

        //console.log(`bite_indicators`,bite_indicators);

        return bite_indicators;
}

//
export function updateUserDataWithSuspendData(userData, suspend_data) {
    return new Promise((resolve, reject) => {
        let suspendDataBites = suspend_data[appHelper.getShortHandKeyByRef("bites").key];
        let suspendDataResources = suspend_data[appHelper.getShortHandKeyByRef("resources").key];
        let suspendDataAttachments = suspend_data[appHelper.getShortHandKeyByRef("attachments").key];
        let suspendDataResponseQuestions = suspend_data[appHelper.getShortHandKeyByRef("short_response_questions").key];
        let suspendDataBadges = suspend_data[appHelper.getShortHandKeyByRef("badges").key];

        let sh_bite_id = appHelper.getShortHandKeyByRef("bite_id").key;
        let sh_screens = appHelper.getShortHandKeyByRef("screens").key;
        let sh_kpis = appHelper.getShortHandKeyByRef("kpis").key;
        let sh_indicators = appHelper.getShortHandKeyByRef("indicators").key;
        let sh_badges = appHelper.getShortHandKeyByRef("badges").key;
        let sh_required = appHelper.getShortHandKeyByRef("required").key;
        let sh_complete_target_screens = appHelper.getShortHandKeyByRef("complete_target_screens").key;
        let sh_terminated = appHelper.getShortHandKeyByRef("terminated").key;
        //console.log(`sh_required: ${sh_required}`);

        let biteBadges = [];

        if (appHelper.isDefined(suspendDataBites)) {
            let biteArray = [];
            for (let i = 0; i < userData.bites.length; i++) {
                let userDataBite = userData.bites[i];
                let suspendDataBite = appHelper.getArrayObjectByKey(suspendDataBites, sh_bite_id, userDataBite.bite_id);

                //retrieve badges from bite for old modules


                if (appHelper.isDefined(suspendDataBite)) {
                    let suspendDataScreens = suspendDataBite[sh_screens];
                    let suspendDataKPIs = suspendDataBite[sh_kpis];
                    let suspendDataIndicators = suspendDataBite[sh_indicators];
                    let suspendDataBiteBadges = suspendDataBite[sh_badges];
                    let suspendDataCompleteTargetScreens = suspendDataBite[sh_complete_target_screens];
                    let userDataBiteBadges = appHelper.isDefined(userDataBite.badges) ? userDataBite.badges : [];
                    let badges = appHelper.isDefined(suspendDataBadges) ? updateBadgesWithSuspendData(userData.badges, suspendDataBadges) : userDataBiteBadges;
                    if(appHelper.isDefined(suspendDataBiteBadges)) {
                        biteBadges = suspendDataBiteBadges.concat(badges);
                    }

                    //console.log(`suspendDataKPIs`,suspendDataKPIs);
                    let newBite = Object.assign({}, userDataBite, {
                        screens: appHelper.isDefined(suspendDataScreens) ? updateBiteScreensWithSuspendData(userDataBite.screens, suspendDataScreens) : userDataBite.screens,
                        kpis: appHelper.isDefined(suspendDataKPIs) ? updateBiteKpisWithSuspendData(userDataBite.kpis, suspendDataKPIs) : userDataBite.kpis,
                        indicators: appHelper.isDefined(suspendDataKPIs) ? updateBiteIndicatorsWithSuspendData(userDataBite.indicators, suspendDataIndicators) : userDataBite.kpis,
                        //badges: badges,
                        complete_target_screens: appHelper.isDefined(suspendDataCompleteTargetScreens) ? updateCompleteTargetScreensWithSuspendData(suspendDataCompleteTargetScreens) : userDataBite.complete_target_screens,
                    });
                    newBite = Object.assign({}, newBite, {
                        status: getBiteStatus(newBite),
                        required: appHelper.getRefByShortHandKey(suspendDataBite[sh_required]).ref,
                        terminated: appHelper.getRefByShortHandKey(suspendDataBite[sh_terminated]).ref,
                        percentageComplete: getBitePercentageComplete(newBite)
                    });
                    biteArray = dataHelpers.immutablePush(biteArray, newBite);
                }

            }
            userData = Object.assign({}, userData, {
                bites: biteArray
            });


            let suspendDataExperienceBadges = suspend_data[sh_badges];

            //let the other data be set before doing this.
            userData = Object.assign({}, userData, {
                status: getLessonStatus(userData.bites),
                percentageComplete: getLessonPercentageComplete(userData.bites),
                lang: appHelper.isDefined(suspend_data.lang) ? suspend_data.lang : userData.lang
            });
        }

        if (appHelper.isDefined(suspendDataResources)) {
            userData = Object.assign({}, userData, {
                resources: updateResourceScreensWithSuspendData(userData.resources, suspendDataResources)
            });
        }

        if (appHelper.isDefined(suspendDataAttachments)) {
            userData = Object.assign({}, userData, {
                attachments: updateAttachmentsWithSuspendData(userData.attachments, suspendDataAttachments)
            });
        }

        if (appHelper.isDefined(suspendDataResponseQuestions)) {
            userData = Object.assign({}, userData, {
                short_response_questions: updateShortResponseQuestionsWithSuspendData(userData.short_response_questions, suspendDataResponseQuestions)
            });
        }

        if (appHelper.isDefined(suspendDataBadges) || biteBadges.length > 0) {
            let experienceBadges = appHelper.isDefined(suspendDataBadges) ? updateBadgesWithSuspendData(userData.badges, suspendDataBadges): [];

            let sh_badge_id = appHelper.getShortHandKeyByRef("badge_id").key;
            let sh_achieved = appHelper.getShortHandKeyByRef("achieved").key;
            let sh_achievedOn = appHelper.getShortHandKeyByRef("achievedOn").key;

            if(biteBadges.length > 0){
                biteBadges = updateBadgesWithSuspendData(userData.badges, biteBadges);

                _.forEach(biteBadges, function (biteBadge, index) {


                    let badgeIndex = appHelper.getArrayObjectIndexByKey(experienceBadges,"badge_id",biteBadge[sh_badge_id]);
                    if(badgeIndex === -1){
                        experienceBadges = dataHelpers.immutablePush(experienceBadges, biteBadge);
                    }else{
                        let experienceBadge  =  experienceBadges[badgeIndex];
                        let achievedArray = Object.assign([],experienceBadge.achievedOn);
                        _.forEach(biteBadge.achievedOn, function (asset_id, index) {
                            let acheivedOnIndex = achievedArray.indexOf(asset_id);
                            if(acheivedOnIndex === -1){
                                achievedArray = dataHelpers.immutablePush(achievedArray, acheivedOnIndex);
                            }
                        });
                        experienceBadge = Object.assign({},experienceBadge,{
                            achievedOn: achievedArray
                        });

                        experienceBadges = dataHelpers.immutableSplice(experienceBadges, badgeIndex, 1, experienceBadge);
                    }
                });
            }

            userData = Object.assign({}, userData, {
                badges: experienceBadges
            });
        }
        //console.log(JSON.stringify(userData));
        resolve(userData);
    });
}

function updateShortResponseQuestionsWithSuspendData(short_response_questions, suspendDataResponseQuestions) {
    let shortResponseQuestionArray = [];
    let sh_id = appHelper.getShortHandKeyByRef("id").key;
    let sh_response = appHelper.getShortHandKeyByRef("response").key;
    for (let i = 0; i < short_response_questions.length; i++) {
        let responseQuestion = short_response_questions[i];
        let suspendDateResponseQuestion = appHelper.getArrayObjectByKey(suspendDataResponseQuestions, sh_id, responseQuestion.id);
        if (appHelper.isDefined(suspendDateResponseQuestion)) {
            responseQuestion = Object.assign({}, responseQuestion, {
                response: suspendDateResponseQuestion[sh_response]
            });
        }
        shortResponseQuestionArray = dataHelpers.immutablePush(shortResponseQuestionArray, responseQuestion);
    }

    return shortResponseQuestionArray;
}

function updateAttachmentsWithSuspendData(attachments, suspendDataAttachments) {
    let attachmentsArray = [];
    let sh_id = appHelper.getShortHandKeyByRef("id").key;
    let sh_type = appHelper.getShortHandKeyByRef("type").key;
    let sh_status = appHelper.getShortHandKeyByRef("status").key;

    for (let i = 0; i < attachments.length; i++) {
        let attachment = attachments[i];
        let suspendDataAttachment = {};
        for (let a = 0; a < suspendDataAttachments.length; a++) {
            let _suspendDataAttachment = suspendDataAttachments[a];
            //console.log(`${_suspendDataAttachment[sh_id]} === ${attachment.id}`);
            if (appHelper.isDefined(_suspendDataAttachment)) {
                if (_suspendDataAttachment[sh_id] === attachment.id && _suspendDataAttachment[sh_type] === appHelper.getShortHandKeyByRef(attachment.type).key) {
                    suspendDataAttachment = Object.assign({}, _suspendDataAttachment);
                }
            }
        }

        if (appHelper.isDefined(suspendDataAttachment.id)) {
            //console.log(`suspendDataAttachment`);
            //console.log(suspendDataAttachment);
            attachment = Object.assign({}, attachment, {
                status: appHelper.getRefByShortHandKey(suspendDataAttachment[sh_status]).ref,
            });
        }

        attachmentsArray = dataHelpers.immutablePush(attachmentsArray, attachment);

    }

    return attachmentsArray;
}

function updateAchievementsWithSuspendData(achievements, suspendDataAchievements) {
    let achievementsArray = [];
    let sh_kpi_id = appHelper.getShortHandKeyByRef("kpi_id").key;
    let sh_achieved = appHelper.getShortHandKeyByRef("achieved").key;
    let sh_achievedOn = appHelper.getShortHandKeyByRef("achievedOn").key;
    for (let i = 0; i < achievements.length; i++) {
        let achievement = achievements[i];
        let suspendDataAchievement = appHelper.getArrayObjectByKey(suspendDataAchievements, sh_kpi_id, achievement.kpi_id);
        if (appHelper.isDefined(suspendDataAchievement)) {
            achievement = Object.assign({}, achievement, {
                achieved: suspendDataAchievement[sh_achieved],
                achievedOn: suspendDataAchievement[sh_achievedOn]
            });
        }
        achievementsArray = dataHelpers.immutablePush(achievementsArray, achievement);
    }
    return achievementsArray;
}


function updateBadgesWithSuspendData(badges, suspendDataBadges) {
    let badgesArray = [];
    let sh_badge_id = appHelper.getShortHandKeyByRef("badge_id").key;
    let sh_achieved = appHelper.getShortHandKeyByRef("achieved").key;
    let sh_achievedOn = appHelper.getShortHandKeyByRef("achievedOn").key;
    for (let i = 0; i < badges.length; i++) {
        let badge = badges[i];
        let suspendDataBadge = appHelper.getArrayObjectByKey(suspendDataBadges, sh_badge_id, badge.badge_id);
        if (appHelper.isDefined(suspendDataBadge)) {
            badge = Object.assign({}, badge, {
                achieved: suspendDataBadge[sh_achieved],
                achievedOn: suspendDataBadge[sh_achievedOn]
            });
        }
        badgesArray = dataHelpers.immutablePush(badgesArray, badge);
    }
    return badgesArray;
}

function updateCompleteTargetScreensWithSuspendData(suspendDataCompleteTargetScreens) {
    let completeTargetScreens = [];
    let sh_screen_id = appHelper.getShortHandKeyByRef("screen_id").key;
    for (let i = 0; i < suspendDataCompleteTargetScreens.length; i++) {
        let suspendDataTargetScreen = suspendDataCompleteTargetScreens[i];
        if (appHelper.isDefined(suspendDataTargetScreen)) {
            let target_screen = {
                screen_id: suspendDataTargetScreen[sh_screen_id],
            };

            completeTargetScreens = dataHelpers.immutablePush(completeTargetScreens, target_screen);
        }
    }

    return completeTargetScreens;
}

function updateResourceScreensWithSuspendData(resources, suspendDataResources) {

    let resourcesScreenArray = [];
    let sh_screen_id = appHelper.getShortHandKeyByRef("screen_id").key;
    let sh_status = appHelper.getShortHandKeyByRef("status").key;
    let sh_objects = appHelper.getShortHandKeyByRef("objects").key;
    for (let i = 0; i < resources.length; i++) {
        let resourceScreen = resources[i];
        let suspendDataScreen = appHelper.getArrayObjectByKey(suspendDataResources, sh_screen_id, resourceScreen.screen_id);
        if (appHelper.isDefined(suspendDataScreen)) {
            let suspendDataObjects = suspendDataResources[sh_objects];

            if (appHelper.isDefined(suspendDataObjects)) {

                resourceScreen = Object.assign({}, resourceScreen, {
                    screen_id: suspendDataScreen[sh_screen_id],
                    status: appHelper.getRefByShortHandKey(suspendDataScreen[sh_status]).ref,
                    objects: updateScreensObjectsWithSuspendData(resourceScreen.objects, suspendDataObjects)
                });
            } else {
                resourceScreen = Object.assign({}, resourceScreen, {
                    screen_id: suspendDataScreen[sh_screen_id],
                    status: appHelper.getRefByShortHandKey(suspendDataScreen[sh_status]).ref,
                    objects: appHelper.getRefByShortHandKey(suspendDataScreen[sh_status]).ref === objectConstants.STATUS_COMPLETE ? setAllScreenObjectsToComplete(resourceScreen.objects) : resourceScreen.objects
                });

            }
            resourcesScreenArray = dataHelpers.immutablePush(resourcesScreenArray, resourceScreen);
        }
    }

    return resourcesScreenArray;
}

function updateBiteScreensWithSuspendData(screens, suspendDataScreens) {
    let screenArray = [];
    let sh_screen_id = appHelper.getShortHandKeyByRef("screen_id").key;
    let sh_status = appHelper.getShortHandKeyByRef("status").key;
    let sh_required = appHelper.getShortHandKeyByRef("required").key;
    let sh_objects = appHelper.getShortHandKeyByRef("objects").key;
    let sh_sub_screens = appHelper.getShortHandKeyByRef("sub_screens").key;
    for (let i = 0; i < screens.length; i++) {
        let screen = screens[i];
        let suspendDataScreen = appHelper.getArrayObjectByKey(suspendDataScreens, sh_screen_id, screen.screen_id);
        if (appHelper.isDefined(suspendDataScreen)) {
            let suspendDataObjects = suspendDataScreen[sh_objects];
            let suspendDataSubScreens = suspendDataScreen[sh_sub_screens];
            if (appHelper.isDefined(suspendDataObjects) && suspendDataObjects.length > 0) {
                screen = Object.assign({}, screen, {
                    screen_id: suspendDataScreen[sh_screen_id],
                    status: appHelper.getRefByShortHandKey(suspendDataScreen[sh_status]).ref,
                    required: appHelper.getRefByShortHandKey(suspendDataScreen[sh_required]).ref,
                    objects: updateScreensObjectsWithSuspendData(screen.objects, suspendDataObjects)
                });
            } else if (appHelper.isDefined(suspendDataSubScreens) && suspendDataSubScreens.length > 0) {
                screen = Object.assign({}, screen, {
                    screen_id: suspendDataScreen[sh_screen_id],
                    status: appHelper.getRefByShortHandKey(suspendDataScreen[sh_status]).ref,
                    required: appHelper.getRefByShortHandKey(suspendDataScreen[sh_required]).ref,
                    sub_screens: updateBiteScreensWithSuspendData(screen.sub_screens, suspendDataSubScreens)
                });
            } else {
                screen = Object.assign({}, screen, {
                    screen_id: suspendDataScreen[sh_screen_id],
                    status: appHelper.getRefByShortHandKey(suspendDataScreen[sh_status]).ref,
                    required: appHelper.getRefByShortHandKey(suspendDataScreen[sh_required]).ref,
                    objects: appHelper.getRefByShortHandKey(suspendDataScreen[sh_status]).ref === objectConstants.STATUS_COMPLETE ? setAllScreenObjectsToComplete(screen.objects) : screen.objects
                });
            }
            screenArray = dataHelpers.immutablePush(screenArray, screen);
        }
    }
    return screenArray;
}

function updateScreensObjectsWithSuspendData(objects, suspendDataObjects) {
    let objectArray = [];
    let sh_asset_id = appHelper.getShortHandKeyByRef("asset_id").key;
    for (let i = 0; i < objects.length; i++) {
        let object = objects[i];
        let suspendDataObject = appHelper.getArrayObjectByKey(suspendDataObjects, sh_asset_id, object.asset_id);
        if (appHelper.isDefined(suspendDataObject)) {
            object = Object.assign({}, object, {
                asset_id: suspendDataObject[sh_asset_id],
                status: objectConstants.STATUS_COMPLETE,
            });

            objectArray = dataHelpers.immutablePush(objectArray, object);
        } else {
            objectArray = dataHelpers.immutablePush(objectArray, object);
        }
    }
    return objectArray;
}

function updateBiteKpisWithSuspendData(kpis, suspendDataKPIs) {
    let kpiArray = [];
    let sh_current = appHelper.getShortHandKeyByRef("current").key;
    let sh_kpi_id = appHelper.getShortHandKeyByRef("kpi_id").key;
    let sh_history = appHelper.getShortHandKeyByRef("history").key;
    for (let i = 0; i < kpis.length; i++) {
        let kpi = kpis[i];
        if (kpi.kpi_id === null) {
            kpi = Object.assign({}, appModels.USER_DATA_BITE_KPI);
        }
        let suspendDataKpi = appHelper.getArrayObjectByKey(suspendDataKPIs, sh_kpi_id, kpi.kpi_id);

        if (appHelper.isDefined(suspendDataKpi) && suspendDataKpi !== null) {
            kpi = Object.assign({}, kpi, {
                current: suspendDataKpi[sh_current],
                currentScoreRange: kpiHelper.getKpiScoreRange(kpi, suspendDataKpi[sh_current]),
            });

            kpi = Object.assign({}, kpi, {
                history: setKpiHistoryWithSuspendData(kpi, suspendDataKpi[sh_history])
            });

            kpiArray = dataHelpers.immutablePush(kpiArray, kpi);
        }
    }
    return kpiArray;
}



function setKpiHistoryWithSuspendData__(kpi, kpiHistorySuspendData) {
    let kpiHistoryArray = [];
    let sh_value = appHelper.getShortHandKeyByRef("value").key;
    let sh_asset_id = appHelper.getShortHandKeyByRef("asset_id").key;
    let sh_option_id = appHelper.getShortHandKeyByRef("option_id").key;
    let sh_current = appHelper.getShortHandKeyByRef("current").key;
    let sh_hasValue = appHelper.getShortHandKeyByRef("hasValue").key;
    let sh_statusIndicatorClass = appHelper.getShortHandKeyByRef("statusIndicatorClass").key;
    for (let i = 0; i < kpiHistorySuspendData.length; i++) {
        let kpiHistory = kpiHistorySuspendData[i];
        let kpiHistoryOptions = kpiHistory[sh_option_id];
        let optionDetails = {};
        let optionKpi = {};
        if (kpiHistoryOptions.length > 0) {
            if (appHelper.isDefined(kpiHistoryOptions[0].option_id)) {
                optionDetails = Object.assign({}, appHelper.getOptionParentDetails(kpiHistoryOptions[0].option_id));
            } else {
                optionDetails = Object.assign({}, appHelper.getOptionParentDetails(kpiHistoryOptions[0]));
            }
            let optionKpis = optionDetails.option.kpis !== null ? optionDetails.option.kpis : [];
            optionKpi = appHelper.getArrayObjectByKey(optionKpis, "kpi_id", kpi.kpi_id);

            if (kpiHistoryOptions.length > 1 && optionDetails.object.asset_type_code !== "compare_answer") {
                let outcome = appHelper.getObjectOutcomeByKpiHistoryOptions(kpiHistoryOptions);
                //let outcomeKpis
                optionKpi = Object.assign({}, appHelper.getArrayObjectByKey(outcome.kpis, "kpi_id", kpi.kpi_id));
            }
        } else {
            optionDetails = Object.assign({}, appHelper.getAssetParentDetails(kpiHistory[sh_asset_id]));
            // optionKpi = kpiHistory;

            let suspendDataOptionKpi = kpiHistory;
            optionKpi = Object.assign({}, optionKpi, {

                value: kpiHistory[sh_statusIndicatorClass][sh_value],

            });
        }


        if (!appHelper.isDefined(optionKpi)) {
            optionKpi = Object.assign({}, {});
        }

        let newKpiHistory = {
            hasValue: kpiHistory[sh_hasValue] === 1,
            value: kpiHistory[sh_value],
            option_id: kpiHistoryOptions.length > 0 ? kpiHistory[sh_option_id] : [],
            screen_id: optionDetails.screen.screen_id,
            asset_id: optionDetails.object.asset_id,
            current: kpiHistory[sh_current],
            currentScoreRange: kpiHelper.getKpiScoreRange(kpi, kpi.current),
            statusIndicatorClass: appHelper.isDefined(optionKpi.value) ? kpiHelper.getKpiPointsIndicatorClass(optionKpi.value, kpi.kpi_id) : kpiHelper.getKpiPointsIndicatorClass("n-a", kpi.kpi_id)
        };

        kpiHistoryArray = dataHelpers.immutablePush(kpiHistoryArray, newKpiHistory);
    }

    return kpiHistoryArray;
}


function setKpiHistoryWithSuspendData(kpi, kpiHistorySuspendData) {
    let kpiHistoryArray = [];
    let sh_value = appHelper.getShortHandKeyByRef("value").key;
    let sh_asset_id = appHelper.getShortHandKeyByRef("asset_id").key;
    let sh_option_id = appHelper.getShortHandKeyByRef("option_id").key;
    let sh_current = appHelper.getShortHandKeyByRef("current").key;
    let sh_hasValue = appHelper.getShortHandKeyByRef("hasValue").key;
    let sh_statusIndicatorClass = appHelper.getShortHandKeyByRef("statusIndicatorClass").key;
    for (let i = 0; i < kpiHistorySuspendData.length; i++) {
        let kpiHistory = kpiHistorySuspendData[i];
        let kpiHistoryOptions = kpiHistory[sh_option_id];
        let optionDetails = {};
        let optionKpi = {};
        if (kpiHistoryOptions.length > 0) {
            if (appHelper.isDefined(kpiHistoryOptions[0].option_id)) {
                optionDetails = Object.assign({}, appHelper.getOptionParentDetails(kpiHistoryOptions[0].option_id));
            } else {
                optionDetails = Object.assign({}, appHelper.getOptionParentDetails(kpiHistoryOptions[0]));
            }
            let optionKpis = optionDetails.option.kpis !== null ? optionDetails.option.kpis : [];
            optionKpi = appHelper.getArrayObjectByKey(optionKpis, "kpi_id", kpi.kpi_id);
            if (kpiHistoryOptions.length > 1 && optionDetails.object.asset_type_code !== "compare_answer") {
                let outcome = {};
                if (optionDetails.object.asset_type_code === "ordering" || optionDetails.object.asset_type_code === "matching") {
                    let checkedOptions = appHelper.getObjectCheckedOptionsByKpiHistoryOptions(kpiHistoryOptions);
                    let options = [];
                    _.forEach(optionDetails.object.options, function (optionData, index) {
                        let option = Object.assign({}, optionData, {
                            answered: true,
                            is_correct: optionData.option_id === checkedOptions[index].option_id,
                            selected_option: checkedOptions[index],
                            default_option: checkedOptions[index]
                        });
                        options = dataHelpers.immutablePush(options, option);
                    });

                    outcome = Object.assign({}, appHelper.getOrderingObjectOutcomeByKpiHistoryOptions(options));
                } else {
                    outcome = Object.assign({}, appHelper.getObjectOutcomeByKpiHistoryOptions(kpiHistoryOptions));
                    //let outcomeKpis

                }
                optionKpi = Object.assign({}, appHelper.getArrayObjectByKey(outcome.kpis, "kpi_id", kpi.kpi_id));
            }
        } else {
            optionDetails = Object.assign({}, appHelper.getAssetParentDetails(kpiHistory[sh_asset_id]));
            // optionKpi = kpiHistory;

            let suspendDataOptionKpi = kpiHistory;
            optionKpi = Object.assign({}, optionKpi, {

                value: kpiHistory[sh_statusIndicatorClass][sh_value],

            });
        }


        if (!appHelper.isDefined(optionKpi)) {
            optionKpi = Object.assign({}, {});
        }

        let newKpiHistory = {
            hasValue: kpiHistory[sh_hasValue] === 1,
            value: kpiHistory[sh_value],
            option_id: kpiHistoryOptions.length > 0 ? kpiHistory[sh_option_id] : [],
            screen_id: optionDetails.screen.screen_id,
            asset_id: optionDetails.object.asset_id,
            current: kpiHistory[sh_current],
            currentScoreRange: kpiHelper.getKpiScoreRange(kpi, kpi.current),
            statusIndicatorClass: appHelper.isDefined(optionKpi.value) ? kpiHelper.getKpiPointsIndicatorClass(optionKpi.value, kpi.kpi_id) : kpiHelper.getKpiPointsIndicatorClass("n-a", kpi.kpi_id)
        };

        kpiHistoryArray = dataHelpers.immutablePush(kpiHistoryArray, newKpiHistory);
    }

    return kpiHistoryArray;
}

function updateBiteIndicatorsWithSuspendData(indicators, suspendDataIndicators){



    let indicatorArray = [];
    let sh_current = appHelper.getShortHandKeyByRef("current").key;
    let sh_indicator_id = appHelper.getShortHandKeyByRef("indicator_id").key;
    let sh_history = appHelper.getShortHandKeyByRef("history").key;
    for (let i = 0; i < indicators.length; i++) {
        let indicator = indicators[i];
        if (indicator.indicator_id === null) {
            indicator = Object.assign({}, appModels.USER_DATA_BITE_INDICATOR);
        }
        let suspendDataIndicator = appHelper.getArrayObjectByKey(suspendDataIndicators, sh_indicator_id, indicator.indicator_id);

        //console.log(`indicator`, indicator, `suspendDataIndicator[sh_current]`, suspendDataIndicator[sh_current]);
        //console.log(`currentOutcome`, indicatorHelper.getIndicatorOutcome(indicator, suspendDataIndicator[sh_current]));


        let currentOutcome = indicatorHelper.getIndicatorOutcome(indicator, suspendDataIndicator[sh_current]);

        if(!appHelper.isDefined(currentOutcome.indicator_outcome_id)){
            currentOutcome = Object.assign({},indicator.outcomes[0]);
        }

        if (appHelper.isDefined(suspendDataIndicator) && suspendDataIndicator !== null) {
            indicator = Object.assign({}, indicator, {
                current: suspendDataIndicator[sh_current],
                currentOutcome: currentOutcome,
            });
            //console.log(`indicator`,indicator);

            indicator = Object.assign({}, indicator, {
                history: seIndicatorHistoryWithSuspendData(indicator, suspendDataIndicator[sh_history])
            });

            indicatorArray = dataHelpers.immutablePush(indicatorArray, indicator);
        }
    }
    return indicatorArray;
}

function seIndicatorHistoryWithSuspendData(indicator, indicatorHistorySuspendData) {
        let indicatorHistoryArray = [];
        let sh_value = appHelper.getShortHandKeyByRef("value").key;
        let sh_asset_id = appHelper.getShortHandKeyByRef("asset_id").key;
        let sh_option_id = appHelper.getShortHandKeyByRef("option_id").key;
        let sh_current = appHelper.getShortHandKeyByRef("current").key;
        //console.log(`seIndicatorHistoryWithSuspendData`,indicator,indicatorHistorySuspendData);
        for (let i = 0; i < indicatorHistorySuspendData.length; i++) {
            let indicatorHistory = indicatorHistorySuspendData[i];
            let indicatorHistoryOptions = indicatorHistory[sh_option_id];
            let optionDetails = {};
            let optionIndicator = {};
            if (indicatorHistoryOptions.length > 0) {
                if (appHelper.isDefined(indicatorHistoryOptions[0].option_id)) {
                    optionDetails = Object.assign({}, appHelper.getOptionParentDetails(indicatorHistoryOptions[0].option_id));
                } else {
                    optionDetails = Object.assign({}, appHelper.getOptionParentDetails(indicatorHistoryOptions[0]));
                }
                let optionIndicators = optionDetails.option.indicators !== null ? optionDetails.option.indicators : [];
                optionIndicator = appHelper.getArrayObjectByKey(optionIndicators, "indicator_id", indicator.indicator_id);

            } else {
                optionDetails = Object.assign({}, appHelper.getAssetParentDetails(indicatorHistory[sh_asset_id]));
                // optionIndicator = indicatorHistory;
            }


            if (!appHelper.isDefined(optionIndicator)) {
                optionIndicator = Object.assign({}, {});
            }

           // console.log(`currentOutcome`, indicatorHelper.getIndicatorOutcome(indicator, indicator.current));

            let currentOutcome = indicatorHelper.getIndicatorOutcome(indicator, indicator.current);

            if(!appHelper.isDefined(currentOutcome.indicator_outcome_id)){
                currentOutcome = Object.assign({},indicator.outcomes[0]);
            }

            let newIndicatorHistory = {
                value: indicatorHistory[sh_value],
                option_id: indicatorHistoryOptions.length > 0 ? indicatorHistory[sh_option_id] : [],
                screen_id: optionDetails.screen.screen_id,
                asset_id: optionDetails.object.asset_id,
                current: indicatorHistory[sh_current],
                currentOutcome: currentOutcome,
            };

            indicatorHistoryArray = dataHelpers.immutablePush(indicatorHistoryArray, newIndicatorHistory);
        }

        return indicatorHistoryArray;
}

export function updateResourceObjectResult(userData, params) {
    return new Promise((resolve, reject) => {

        let resourceScreens = [];
        _.forEach(userData.resources, function (resourceScreen) {
            let resourceObjects = [];
            _.forEach(resourceScreen.objects, function (resource) {

                if (resource.asset_id === params.asset_id) {
                    resource = Object.assign({}, resource, {
                        status: params.status
                    });
                }
                resourceObjects = dataHelpers.immutablePush(resourceObjects, resource);
            });

            resourceScreen = Object.assign({}, resourceScreen, {
                objects: Object.assign([], resourceObjects)
            });

            resourceScreen = Object.assign({}, resourceScreen, {
                status: getResourceScreenStatus(resourceScreen)
            });

            resourceScreens = dataHelpers.immutablePush(resourceScreens, resourceScreen);
        });

        let attachments = [];
        _.forEach(userData.attachments, function (attachment) {

            if (attachment.id === params.asset_id && attachment.type === params.asset_type_code) {
                attachment = Object.assign({}, attachment, {
                    status: params.status
                });
            }
            attachments = dataHelpers.immutablePush(attachments, attachment);
        });

        userData = Object.assign({}, userData, {
            resources: Object.assign([], resourceScreens),
            attachments: Object.assign([], attachments)
        });

        resolve(userData);
    });

}


export function getResourceScreenStatus(screen) {
    let completeCount = 0;
    for (let i = 0; i < screen.objects.length; i++) {
        let object = screen.objects[i];
        if (object.status === objectConstants.STATUS_COMPLETE) {
            completeCount++;
        }
    }
    if (screen.status === objectConstants.STATUS_COMPLETE) {
        return objectConstants.STATUS_COMPLETE;
    } else if (completeCount === 0) {
        return objectConstants.STATUS_NOT_STARTED;
    } else if (completeCount === screen.objects.length) {
        return objectConstants.STATUS_COMPLETE;
    } else {
        return objectConstants.STATUS_IN_PROGRESS;
    }
}

export function getRequiredScreenCount(bite) {
    let requiredCount = 0;
    for (let i = 0; i < bite.screens.length; i++) {
        let screen = bite.screens[i];
        //console.log(screen);

        if (screen.required && !screen.isTargetScreen) {
            //console.log(`${screen.required} && ${!screen.isTargetScreen}`);
            requiredCount++;
        }
    }

    return requiredCount;
}


export function getBiteStatus(bite) {
    //console.log(`getBiteStatus`);
    let bite_id = bite.bite_id;
    let biteStatus = objectConstants.STATUS_NOT_STARTED;
    let completeScreenCount = 0;
    let notRequiredScreenCount = 0;
    let multiPathCompleteScreenCount = 0;
    let completeWithNotRequiredCount = 0;

    for (let i = 0; i < bite.screens.length; i++) {
        let screen = bite.screens[i];
        if (screen.required && screen.status === objectConstants.STATUS_COMPLETE && !screen.isTargetScreen) {
            completeScreenCount++;
            completeWithNotRequiredCount++;
        } else if (screen.status === objectConstants.STATUS_NOT_REQUIRED) {
            notRequiredScreenCount++;
            completeWithNotRequiredCount++;
        }
    }

    //console.log(`${completeScreenCount} >= ${getRequiredScreenCount(bite)}`)
    if (completeScreenCount >= getRequiredScreenCount(bite)) {
        //console.log(`${completeScreenCount} >= ${getRequiredScreenCount(bite)}`)
        //console.log(`${bite.complete_target_screens.length} >= ${bite.number_of_target_screens}`);
        if (bite.complete_target_screens.length >= bite.number_of_target_screens) {
            biteStatus = objectConstants.STATUS_COMPLETE;
        } else {
            biteStatus = objectConstants.STATUS_IN_PROGRESS;
        }
    } else if (notRequiredScreenCount >= bite.screens.length) {
        biteStatus = objectConstants.STATUS_NOT_REQUIRED;
    } else if (completeScreenCount > 0 && completeScreenCount < bite.screens.length) {
        biteStatus = objectConstants.STATUS_IN_PROGRESS;
    }

    if (completeWithNotRequiredCount >= bite.screens.length && notRequiredScreenCount > 0 && completeScreenCount > 0) {
        biteStatus = objectConstants.STATUS_COMPLETE;
    }

    if (bite.terminated) {
        biteStatus = objectConstants.STATUS_COMPLETE;
    }


    return biteStatus;
}


export function getBiteRequired(bite) {
    let biteRequired = true;
    let requiredCount = getRequiredScreenCount(bite);
    if (requiredCount === 0) {
        biteRequired = false;
    }

    return biteRequired;
}

export function getBitePercentageComplete(bite) {
    if (bite.terminated) {
        return 100;
    } else {
        return _getBitePercentageComplete(bite);
    }
}

function _getBitePercentageComplete(bite) {
    let screens = bite.screens;
    let requiredScreenCount = getRequiredScreenCount(bite);
    let requiredTargetScreens = bite.number_of_target_screens;
    let totalScreenCount = requiredScreenCount + requiredTargetScreens;
    let completeScreenCount = bite.complete_target_screens.length > requiredTargetScreens ? requiredTargetScreens : bite.complete_target_screens.length;

    for (let i = 0; i < screens.length; i++) {
        let screen = screens[i];
        if (screen.required && screen.status === objectConstants.STATUS_COMPLETE && !screen.isTargetScreen) {
            completeScreenCount++;
        }
    }


    return Math.round((completeScreenCount / totalScreenCount) * 100);
}

export function getLessonStatus(bites) {
    let biteStatus = objectConstants.STATUS_NOT_STARTED;
    let inprogressBiteCount = 0;
    let completeBiteCount = 0;

    for (let i = 0; i < bites.length; i++) {
        let bite = bites[i];
        if (bite.required) {
            if (bite.status === objectConstants.STATUS_IN_PROGRESS) {
                inprogressBiteCount++;
            } else if (bite.status === objectConstants.STATUS_COMPLETE) {
                completeBiteCount++;
            }
        } else {
            completeBiteCount++;
        }
    }
    if (completeBiteCount >= bites.length) {
        biteStatus = objectConstants.STATUS_COMPLETE;
    } else if ((completeBiteCount > 0 && completeBiteCount < bites.length) || inprogressBiteCount > 0) {
        biteStatus = objectConstants.STATUS_IN_PROGRESS;
    }
    return biteStatus;
}

export function getLessonPercentageComplete(bites) {
    let percentageComplete = 0;

    for (let i = 0; i < bites.length; i++) {
        let bite = bites[i];
        if (bite.required) {
            percentageComplete = percentageComplete + bite.percentageComplete;
        } else {
            percentageComplete = percentageComplete + 100;
        }
    }
    return Math.round(percentageComplete / bites.length);

}

export function getBiteUserData(userData, bite_id) {
    for (let i = 0; i < userData.bites.length; i++) {
        for (let i = 0; i < userData.bites.length; i++) {
            let bite = userData.bites[i];
            if (bite.bite_id === bite_id) {
                return bite;
            }
        }
    }
    return undefined;
}

export function getScreenUserData(userData, screen_id) {
    for (let i = 0; i < userData.bites.length; i++) {
        let bite = userData.bites[i];
        for (let s = 0; s < bite.screens.length; s++) {
            let screen = bite.screens[s];
            if (screen.screen_id === screen_id) {
                return screen;
            }
        }
    }
    return undefined;
}

export function getSubScreenUserData(userData, parent_screen_id, screen_id) {
    let sub_screen_obj = {};
    _.forEach(userData.bites, function (bite) {
        _.forEach(bite.screens, function (screen) {
            if (screen.screen_id === parent_screen_id) {
                _.forEach(screen.sub_screens, function (sub_screen) {
                    if (sub_screen.screen_id === screen_id) {

                        sub_screen_obj = Object.assign({}, sub_screen);
                    }
                });
            }
        });
    });

    return sub_screen_obj;
}


export function getObjectStatus(userData, screen_id, asset_id) {
    //console.log(userData);
    //console.log(asset_id);
    for (let i = 0; i < userData.bites.length; i++) {
        let bite = userData.bites[i];
        for (let s = 0; s < bite.screens.length; s++) {
            let screen = bite.screens[s];
            if (screen.screen_id === screen_id) {
                if (appHelper.isDefined(screen.objects)) {
                    for (let o = 0; o < screen.objects.length; o++) {
                        let object = screen.objects[o];
                        if (object.asset_id === asset_id) {
                            return object;
                        }
                    }
                }
            }
        }
    }
    return undefined;
}

export function getSubScreenObjectStatus(userData, screen_id, sub_screen_id, asset_id) {
    //console.log(userData);
    //console.log(asset_id);
    for (let i = 0; i < userData.bites.length; i++) {
        let bite = userData.bites[i];
        for (let s = 0; s < bite.screens.length; s++) {
            let screen = bite.screens[s];
            if (screen.screen_id === screen_id) {
                if (appHelper.isDefined(screen.sub_screens)) {
                    for (let b = 0; b < screen.sub_screens.length; b++) {
                        let sub_screen = screen.sub_screens[b];
                        if (sub_screen.screen_id === sub_screen_id) {
                            if (appHelper.isDefined(sub_screen.objects)) {
                                for (let o = 0; o < sub_screen.objects.length; o++) {
                                    let object = sub_screen.objects[o];
                                    if (object.asset_id === asset_id) {
                                        return object;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    return undefined;
}


export function getResourceScreenUserData(userData, screen_id) {
    let resourceScreen = {};
    _.forEach(userData.resources, function (resource) {
        if (resource.screen_id === screen_id) {
            resourceScreen = Object.assign({}, resource);
        }
    });

    return resourceScreen;
}

export function getResourceScreenObjectUserData(userData, screen_id, asset_id) {
    let resourceObject = {};
    _.forEach(userData.resources, function (resource) {
        if (resource.screen_id === screen_id) {
            _.forEach(resource.objects, function (object) {
                if (object.asset_id === asset_id) {
                    resourceObject = Object.assign({}, object);
                }
            });
        }
    });

    return resourceObject;
}

export function getAttachmentObjectUserData(userData, asset_id) {
    let attachmentObject = {};
    _.forEach(userData.attachments, function (attachment) {
        if (attachment.id === asset_id) {
            attachmentObject = Object.assign({}, attachment);
        }
    });

    return attachmentObject;
}

export function getBiteKpi(usrData, bite_id, kpi_id) {
    let bite = appHelper.getArrayObjectByKey(usrData.bites, "bite_id", bite_id);
    return appHelper.getArrayObjectByKey(bite.kpis, "kpi_id", kpi_id);
}

export function getUserResponseByOptionIds(userData, bite_id, optionIds) {
    let result = undefined;
    //console.log(`getUserResponseByOptionIds`,userData, bite_id, optionIds);
    let bite = appHelper.getArrayObjectByKey(userData.bites, "bite_id", bite_id);
    //console.log(`bite`, bite);
    if (bite.kpis.length > 0) {
        let primaryKpi = kpiHelper.getPrimaryKpi(bite.kpis);
        if (!appHelper.isDefined(primaryKpi)) {
            primaryKpi = getBiteKpi(userData, bite.bite_id, 0);
        }
        for (let i = 0; i < primaryKpi.history.length; i++) {
            let history = primaryKpi.history[i];
            for (let h = 0; h < history.option_id.length; h++) {
                let historyOptionId = history.option_id[h];
                if (optionIds.indexOf(historyOptionId) > -1) {
                    result = Object.assign({},history);
                }
            }
        }
    }

    if(!appHelper.isDefined(result) && bite.indicators.length > 0) {
        //console.log(`here`, bite.indicators.length);
        _.forEach(bite.indicators, function (indicator) {
           // console.log(`here`, indicator.history);
            if(indicator.history.length > 0){
                _.forEach(indicator.history, function (history) {
                    //console.log(history.option_id);
                    for (let h = 0; h < history.option_id.length; h++) {

                        let historyOptionId = history.option_id[h];

                        if (optionIds.indexOf(historyOptionId) > -1) {
                            result = Object.assign({},history);
                        }
                    }
                });
            }
        });
    }

    return result;
}

export function getUserInputResponseByOptionIds(userData, bite_id, optionIds) {
    //console.log(`getUserResponseByOptionIds`);
    //console.log(bite_id);
    //console.log(optionIds);
    let bite = appHelper.getArrayObjectByKey(userData.bites, "bite_id", bite_id);

    let primaryKpi = kpiHelper.getPrimaryKpi(bite.kpis);
    //console.log(primaryKpi);
    for (let i = 0; i < primaryKpi.history.length; i++) {
        let history = primaryKpi.history[i];
        //console.log(history);
        for (let h = 0; h < history.option_id.length; h++) {
            let historyOptionId = history.option_id[h];
            if (appHelper.isDefined(historyOptionId.option_id)) {
                return history;
            }
        }
        //option_id
    }
}

export function getToolboxScreenUserData(userData, toolbox_id) {
    let toolbox = userData.toolbox;
    let toolbox_screen = appHelper.getArrayObjectByKey(toolbox.screens, "toolbox_id", toolbox_id);
    return toolbox_screen;
}

export function getToolboxObjectStatus(userData, toolbox_id, asset_id) {
    let toolbox = userData.toolbox;
    let toolbox_screen = appHelper.getArrayObjectByKey(toolbox.screens, "toolbox_id", toolbox_id);
    let object = appHelper.getArrayObjectByKey(toolbox_screen.objects, "asset_id", asset_id);
    return object;
}

export function getScreenMultiPathResult(multiPath, userData, bite_id) {
    let bite = appHelper.getArrayObjectByKey(userData.bites, "bite_id", bite_id);
    let kpis = bite.kpis;
    let selectedPath = {};

    for (let i = 0; i < multiPath.paths.length; i++) {
        let path = multiPath.paths[i];
        let matches = 0;
        for (let k = 0; k < kpis.length; k++) {
            let kpi = kpis[k];
            let pathKpi = appHelper.getArrayObjectByKey(path.kpis, "kpi_id", kpi.kpi_id);
            if (kpi.current === pathKpi.value) {
                matches++;
            }
        }
        if (matches === path.kpis.length) {
            selectedPath = Object.assign({}, path);
        }
    }
    return selectedPath;


}

export function getSavedObjects(userData, bite_id) {
    let savedObjects = [];
    let bite = appHelper.getArrayObjectByKey(userData.bites, "bite_id", bite_id);
    for (let s = 0; s < bite.screens.length; s++) {
        let screen = bite.screens[s];
        for (let o = 0; o < screen.objects.length; o++) {
            let object = screen.objects[o];
            if (object.status === objectConstants.STATUS_SAVED) {
                savedObjects = dataHelpers.immutablePush(savedObjects, object);
            }
        }
    }

    return savedObjects;
}


//Collect Badge
export function collectBadge(userData, params) {
    return new Promise((resolve, reject) => {
        let bites = Object.assign([],userData.bites);
        //let bite = appHelper.getArrayObjectByKey(userData.bites, "bite_id", params.bite_id);
        //let biteIndex = appHelper.getArrayObjectIndexByKey(userData.bites, "bite_id", params.bite_id);

        //let badgeIndex = appHelper.getArrayObjectIndexByKey(bite.badges, "badge_id", params.badge.badge_id);
        //let badge = appHelper.getArrayObjectByKey(bite.badges, "badge_id", params.badge.badge_id);
        let experienceBadgeIndex = appHelper.getArrayObjectIndexByKey(userData.badges, "badge_id", params.badge.badge_id);
        let experienceBadge = appHelper.getArrayObjectByKey(userData.badges, "badge_id", params.badge.badge_id);
        let achievedOnIndex = experienceBadge.achievedOn.indexOf(params.asset_id);

       /* badge = Object.assign({}, badge, {
            achieved: badge.achieved + 1,
            achievedOn: achievedOnIndex === -1 ? dataHelpers.immutablePush(badge.achievedOn, params.asset_id) : badge.achievedOn
        });*/

        experienceBadge = Object.assign({}, experienceBadge, {
            achieved: experienceBadge.achieved + 1,
            achievedOn: achievedOnIndex === -1 ? dataHelpers.immutablePush(experienceBadge.achievedOn, params.asset_id) : experienceBadge.achievedOn
        });

        /*let badges = dataHelpers.immutableSplice(bite.badges, badgeIndex, 1, badge);
        bite = Object.assign({}, bite, {
            badges: Object.assign([], badges)
        });

        let bites = dataHelpers.immutableSplice(userData.bites, biteIndex, 1, bite);*/




        let experienceBadges = dataHelpers.immutableSplice(userData.badges, experienceBadgeIndex, 1, experienceBadge);

        if (appHelper.isDefined(localStorage.contentData.experience.experience_learning_model)) {
            if (appHelper.isDefined(localStorage.contentData.experience.learning_plan)) {
                let biteMenu = Object.assign({}, localStorage.contentData.experience.learning_plan);
                bites = setBiteRequiredByRules(biteMenu, bites, experienceBadges);
            }
        }


        userData = Object.assign({}, userData, {
            bites: bites,
            badges: Object.assign([], experienceBadges)
        });
        resolve(userData);
    });

}

export function checkBadgeEarnedOnObject(userData, params) {
    let earnedBadges = [];
    //let bite = appHelper.getArrayObjectByKey(userData.bites, "bite_id", params.bite_id);
    for (let i = 0; i < userData.badges.length; i++) {
        let badge = userData.badges[i];
        for (let j = 0; j < badge.achievedOn.length; j++) {
            let achievedOn_asset_id = badge.achievedOn[j];
            if (achievedOn_asset_id === params.asset_id) {
                earnedBadges = dataHelpers.immutablePush(earnedBadges, badge);
            }
        }
    }
    return earnedBadges;
}

export function getUsersDataBadges(allBadges, selectedBadges) {
    let returnBadges = [];
    //let bite = appHelper.getArrayObjectByKey(userData.bites, "bite_id", params.bite_id);
    for (let i = 0; i < allBadges.length; i++) {
        let badge = allBadges[i];
        if(appHelper.getArrayObjectIndexByKey(selectedBadges,"badge_id",badge.badge_id) > -1){
            returnBadges = dataHelpers.immutablePush(returnBadges,badge);
        }

    }
    return returnBadges;
}

export function getKpiAverage(userData, bite_id) {
    let bite = appHelper.getArrayObjectByKey(userData.bites, "bite_id", bite_id);
    let current = 0;
    let total = 0;
    for (let i = 0; i < bite.kpis.length; i++) {
        let kpi = bite.kpis[i];
        current = current + kpi.current;
        total = total + kpi.max;
    }

    return Math.round((current / total) * 100);
}


//Collect Achievement
export function saveNotes(userData, params) {
    return new Promise((resolve, reject) => {
        let notesIndex = appHelper.getArrayObjectIndexByKey(userData.notes, "screen_id", params.screen_id);
        userData = Object.assign({}, userData, {
            notes: notesIndex === -1 ? dataHelpers.immutablePush(userData.notes, params) : dataHelpers.immutableSplice(userData.notes, notesIndex, 1, params)
        });
        resolve(userData);
    });

}

export function getAllUserBadges(userData) {
    let allBadges = [];
    _.forEach(userData.badges, function (badge) {
        let badgeIndex = appHelper.getArrayObjectIndexByKey(allBadges, "badge_id", badge.badge_id);
        if (badgeIndex === -1) {
            allBadges = dataHelpers.immutablePush(allBadges, badge);
        }
    });
    return allBadges;
}

export function storeUserShortResponses(params) {
    return new Promise((resolve, reject) => {
        let userData = Object.assign({}, params.userData);
        let short_response_questions = Object.assign([], userData.short_response_questions);

        _.forEach(params.answeredQuestions, function (question) {
            let data_question = appHelper.getArrayObjectByKey(short_response_questions, "id", question.id);

            let data_questionIndex = appHelper.getArrayObjectIndexByKey(short_response_questions, "id", question.id);

            data_question = Object.assign({}, data_question, {
                response: question.response
            });
            short_response_questions = dataHelpers.immutableSplice(short_response_questions, data_questionIndex, 1, data_question);
        });


        userData = Object.assign({}, userData, {
            short_response_questions: short_response_questions
        });


        //console.log(userData);
        resolve(userData);
    });
}



/** WEBPACK FOOTER **
 ** ./src/helpers/userDataHelper.js
 **/